import { RootState } from '../store';
import { Key } from './feed.types';

const getState = (state: RootState) => state.feed;
export const keyDataSelector = (key: Key) => (state: RootState) => getState(state)[key];

export const selectTotalFeedResultsNumber = (state: RootState) => getState(state).totalFeedResultsNumber.data;
